// css:
import './components/styles/styles.scss';
import './components/designerOverlayModal/designerOverlayModal.scss';
import './components/transforToCartOverlayModal/transforToCartOverlayModal.scss';
import './components/confirmationModal/confirmationModal.scss';

// scripts:
import './components/logoCreatorMiddleWare/logoCreatorMiddleware';
